"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _uiKit = require("@dbi-tools/ui-kit");

var _container = require("@dbi-tools/ui-kit/lib/components/container");

var _sectionHeadline = require("./section-headline.styled");

var _themeOptions = require("../../helpers/theme-options");

var _useStyles = require("../../hooks/useStyles");

var _style = _interopRequireDefault(require("./style"));

var _headerTitles = require("../header-titles");

var _const = require("./const");

var _const2 = require("../../const");

var _useMedia = require("../../hooks/use-media");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SectionHeadline = function SectionHeadline(props) {
  var id = props.id,
      headline1 = props.headline1,
      headline2 = props.headline2,
      description = props.description,
      _props$theme = props.theme,
      currentTheme = _props$theme === void 0 ? _themeOptions.ThemeVariants.WHITE : _props$theme,
      removeBottomPadding = props.removeBottomPadding,
      removeTopPadding = props.removeTopPadding;
  var _headlineThemeStrateg = _const.headlineThemeStrategy[currentTheme],
      headline1Color = _headlineThemeStrateg.headline1Color,
      headline2Color = _headlineThemeStrateg.headline2Color;
  var basicStyles = (0, _useStyles.useStyles)('a', _style.default);
  var isMobile = (0, _useMedia.useMedia)(_const2.Breakpoints.MOBILE);
  var paddingSize = isMobile ? _const2.MOBILE_PADDING_SIZE : _const2.DEFAULT_PADDING_SIZE;
  var bottomPadding = removeBottomPadding ? 0 : paddingSize;
  var topPadding = removeTopPadding ? 0 : paddingSize;
  var containerPadding = [topPadding, 0, bottomPadding];
  var theme = {
    $theme: currentTheme,
    $styles: basicStyles
  };
  return /*#__PURE__*/_react.default.createElement(_uiKit.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(_sectionHeadline.SectionHeadlineStyled, {
    p: containerPadding,
    id: id
  }, /*#__PURE__*/_react.default.createElement(_container.Container, null, /*#__PURE__*/_react.default.createElement(_headerTitles.HeaderTitles, {
    headline1: headline1,
    headline2: headline2,
    description: description,
    headline1Color: headline1Color,
    headline2Color: headline2Color,
    noGutters: true
  }))));
};

var _default = SectionHeadline;
exports.default = _default;